module.exports = __webpack_public_path__ + "static/media/capture_border.db75c7df.png";